import { useEffect, useMemo, useState } from 'react'
import { WorkOrdersTable } from '../../components/work-orders-table'
import { type Stores } from '../../util/store'
import { observer } from 'mobx-react-lite'
import { useOrganizations } from '../../stores/organization-store'

export interface WorkOrdersPageProps {
    stores: Stores
}

const WorkOrdersPage = observer(({ stores }: WorkOrdersPageProps) => {
    const organizations = useOrganizations(stores.organizations)
    const [pagination, setPagination] = useState({})
    const [filters, setFilters] = useState({})
    const [sorting, setSorting] = useState<string[]>([])

    const options = useMemo(() => {
        return {
            ...pagination,
            ...filters,
            sort_by: sorting,
        }
    }, [pagination, filters, sorting])

    useEffect(() => {
        void stores.workOrders.list(options)
    }, [options, stores.workOrders])

    return (
        <div data-testid="work-orders-page" style={{ display: 'contents' }}>
            <WorkOrdersTable
                workOrders={stores.workOrders.workOrders}
                organizations={organizations}
                rowCount={stores.workOrders.totalWorkOrders}
                pagination={stores.workOrders.pagination}
                filters={filters}
                sorting={sorting}
                setPagination={setPagination}
                setFilters={setFilters}
                setSorting={setSorting}
                isLoading={stores.workOrders.isFetching}
                isPrimaryBackgroundColor
            />
        </div>
    )
})

export { WorkOrdersPage }
